import { Component, Injector } from '@angular/core';
import { ActionButtonComponent } from './action-button.component';
import { BackButtonComponent } from './back-button.component';
import { BaseButtonComponent } from './base-button.component';
import { BorderIconButtonComponent } from './border-icon-button.component';
import { CircleButtonComponent } from './circle-button.component';
import { DialogButtonComponent } from './dialog-button.component';
import { PageButtonComponent } from './page-button.component';
import { PaymentButtonButtonComponent } from './payment-button.component';
import { PlainButtonComponent } from './plain-button.component';
import { PlusMinusButtonComponent } from './plus-minus-button.component';
import { SmallActionButtonComponent } from './small-action-button.component';
import { TipButtonComponent } from './tip-button.component';
import { CommonModule } from '@angular/common';
import { UrlHistoryService } from '../../services/url.history.service';
import {PrepaidCardComponent} from '../prepaid-card/prepaid-card.component';
import {LightIconButtonComponent} from './light-icon-button-component';
import {PlusMinusSMButtonComponent} from './plus-minus-sm-button.component';

@Component({
  selector: 'app-button-preview',
  standalone: true,
  imports: [
    CircleButtonComponent,
    CommonModule,
    PrepaidCardComponent
  ],
  template: `
  <div #contentDiv class="max-w-lg mx-auto flex flex-col pt-20 min-h-[calc(100vh)]">
    <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-full p-4 text-theme-text">
      <div class="flex items-center space-x-4">
        <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl"
          (onClick)="back()"></app-circle-button>
        <div class="text-lg text-theme-text font-semibold">Preview knappar</div>
      </div>
      <div *ngFor="let button of buttons" class="border p-4 mt-4 rounded shadow">
        <h3 class="font-bold mb-2">{{ button.name }}</h3>
        <ng-container *ngComponentOutlet="button.component"></ng-container>
      </div>

      <div class="mt-8">
        <div class="font-bold">TEXT SIZES</div>
        <div class="text-xs">(text-xs) Brown fox jumped</div>
        <div class="text-sm">(text-sm) Brown fox jumped</div>
        <div class="text-base">(text-base) Brown fox jumped</div>
        <div class="text-lg">(text-lg) Brown fox jumped</div>
        <div class="text-xl">(text-xl) Brown fox jumped</div>
        <div class="text-2xl">(text-2xl) Brown fox jumped</div>
        <div class="text-3xl">(text-3xl) Brown fox jumped</div>
      </div>

      <div class="mt-8">
        <div class="font-bold">TEXT WEIGHTS</div>
        <div class="font-light">(font-light) Brown fox jumped</div>
        <div class="font-normal">(font-normal) Brown fox jumped</div>
        <div class="font-medium">(font-medium) Brown fox jumped</div>
        <div class="font-semibold">(font-semibold) Brown fox jumped</div>
        <div class="font-bold">(font-bold) Brown fox jumped</div>
        <div class="font-black">(font-black) Brown fox jumped</div>
      </div>

      <!--  tabular vs non tabular    -->
      <div class="mt-8">
        <div class="font-bold">TABULAR NUMS</div>
        <div class="grid grid-cols-2 grid-rows-2">
          <div>(tabular-nums)</div>
          <div class="tabular-nums">1234567890</div>
          <div>(proportional-nums)</div>
          <div>1234567890</div>
        </div>
      </div>

      <div class="mt-8">
        <div class="font-bold">COLORS</div>
        <div class="grid grid-cols-3 gap-4">
          <div>theme-primary:</div>
          <span class="text-theme-primary">Brown fox jumped</span>
          <span class="bg-theme-primary">ABCDEFGH</span>

          <div>theme-text:</div>
          <span class="text-theme-text">Brown fox jumped</span>
          <span class="bg-theme-text">ABCDEFGH</span>

          <div>theme-text2:</div>
          <span class="text-theme-text2">Brown fox jumped</span>
          <span class="bg-theme-text2">ABCDEFGH</span>

          <div>theme-text3:</div>
          <span class="text-theme-text3">Brown fox jumped</span>
          <span class="bg-theme-text3">ABCDEFGH</span>

          <div>theme-surface:</div>
          <span class="text-theme-surface">Brown fox jumped</span>
          <span class="bg-theme-surface">ABCDEFGH</span>

          <div>theme-surface2:</div>
          <span class="text-theme-surface2">Brown fox jumped</span>
          <span class="bg-theme-surface2">ABCDEFGH</span>

          <div>theme-notification:</div>
          <span class="text-theme-notification">Brown fox jumped</span>
          <span class="bg-theme-notification text-theme-notification-text">ABCDEFGH</span>

          <div>theme-notification2:</div>
          <span class="text-theme-notification2">Brown fox jumped</span>
          <span class="bg-theme-notification2 text-theme-notification2-text">ABCDEFGH</span>

          <div>theme-warning:</div>
          <span class="text-theme-warning">Brown fox jumped</span>
          <span class="bg-theme-warning">ABCDEFGH</span>
        </div>
      </div>

    </div>
  </div>
  `,
})
export class ButtonPreviewComponent {
  buttons = [
    { name: 'Action Button', component: ActionButtonComponent, inputs: { text: 'Action Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Back Button', component: BackButtonComponent, inputs: { text: 'Back Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Base Button', component: BaseButtonComponent, inputs: { text: 'Base Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Border Icon Button', component: BorderIconButtonComponent, inputs: { text: 'Border Icon Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Circle Button', component: CircleButtonComponent, inputs: { text: 'Circle Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Dialog Button', component: DialogButtonComponent, inputs: { text: 'Dialog Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Page Button', component: PageButtonComponent, inputs: { text: 'Page Button', icon: 'fa-regular fa-lightbulb' } },
    //{ name: 'Payment Button', component: PaymentButtonComponent, inputs: { text: 'Payment Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Plain Button', component: PlainButtonComponent, inputs: { text: 'Plain Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Plus Minus Button', component: PlusMinusButtonComponent, inputs: { text: 'Plus Minus Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Plus Minus Small Button', component: PlusMinusSMButtonComponent, inputs: { text: 'Plus Minus Small Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Small Action Button', component: SmallActionButtonComponent, inputs: { text: 'Small Action Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Tip Button', component: TipButtonComponent, inputs: { text: 'Tip Button', icon: 'fa-regular fa-lightbulb' } },
    { name: 'Light Icon', component: LightIconButtonComponent, inputs: { text: 'Light Icon', icon: 'fa-regular fa-lightbulb' } }
  ];

  constructor(private identityService: UrlHistoryService) { }

  createInjector(button: any) {
    return Injector.create({
      providers: Object.keys(button.inputs || {}).map(key => ({
        provide: key,
        useValue: button.inputs[key]
      }))
    });
  }

  back() {
    this.identityService.navigateBack();
  }
}
